export enum TutorSlotLogAction {
  Created = 'CREATED',
  Updated = 'UPDATED',
}

export enum TutorSlotLogField {
  Status = 'status',
  BookingId = 'booking_id',
}
